// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3kUHH","detailsBorder":"styles_detailsBorder__28Cx5"};